module.exports = {
  detailObj: {},
}



// WEBPACK FOOTER //
// ./src/store/sessionInfo/state.js